import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const HeroSection = ({ data }) => {
  const imgPath = process.env.REACT_APP_IMAGES;

  if (!data) return null;

  const style = {
    "--hero-bg-desktop": `url(${imgPath}${data.bgDesktop})`,
    "--hero-bg-tablet": `url(${imgPath}${data.bgTablet})`,
  };

  return (
    <section className="hero-section" style={style}>
      <div className="hero-gradient-container">
        <div className="hero-blob hero-blob-1" />
        <div className="hero-blob hero-blob-2" />
        <div className="hero-blob hero-blob-3" />
        <div className="hero-blob hero-blob-4" />
      </div>
      <Container className="hero-content">
        <Row>
          <Col lg={8} className="hero-text-col">
            {/* Desktop/Tablet tagline */}
            <div className="hero-tagline-row hero-tagline-desktop">
              <span className="hero-orange-square" />
              <span className="hero-tagline">{parse(data.tagline)}</span>
            </div>
            {/* Mobile tagline */}
            <div className="hero-tagline-mobile">
              <p className="hero-tagline"><span className="hero-orange-square" /> {parse(data.taglineLine1 || 'The Keynote')}</p>
              <p className="hero-tagline">{parse(data.taglineLine2 || 'Mindset Summit Las Vegas 2026')}</p>
            </div>
            <h1 className="hero-title">{parse(data.titleLine1)}</h1>
            <h1 className="hero-title">{parse(data.titleLine2)}</h1>
            <h1 className="hero-title">{parse(data.titleLine3)}</h1>
            <img
              src={`${imgPath}${data.bgMobile}`}
              alt=""
              className="hero-mobile-img"
            />
            <div className="hero-desc-row">
              <span className="hero-orange-line" />
              <p className="hero-description">{parse(data.description)}</p>
            </div>
          </Col>
          <Col lg={4} />
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
